<script setup lang="ts">
const props = defineProps<{
  src?: string
  fallbackSrc?: string
  height?: number
  altLabel?: string
}>()

const imageUrl = ref(props.src || props.fallbackSrc)

function onError() {
  imageUrl.value = props.fallbackSrc
}

const dimension = computed(() => {
  if (props.height)
    return props.height
  return props.src ? 215 : 125
})
</script>

<template>
  <div :style="`height: ${dimension}px;`" class="d-flex w-100">
    <NuxtImg
      :src="imageUrl"
      :alt="altLabel || 'product image'"
      :height="dimension"
      :width="dimension"
      class="product-image"
      @error="onError"
    />
  </div>
</template>

<style scoped>
.product-image {
  object-fit: contain;
}
</style>
